define("shared/utils/browser-zoom", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getBrowserZoomDirection = getBrowserZoomDirection;
  _exports.getBrowserZoomResetInstructionsKey = getBrowserZoomResetInstructionsKey;
  _exports.getBrowserZoomScale = getBrowserZoomScale;
  _exports.initBrowserZoomDetection = initBrowserZoomDetection;
  _exports.isBrowserZoomAtDefault = isBrowserZoomAtDefault;
  _exports.isMac = isMac;
  _exports.isSafari = isSafari;
  _exports.resetBrowserZoomStateForTests = resetBrowserZoomStateForTests;
  _exports.setBrowserZoomBaselinesForTests = setBrowserZoomBaselinesForTests;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  const DEFAULT_ZOOM_SCALE = 1;
  const ZOOM_TOLERANCE = 0.01;
  let baselineDevicePixelRatio;
  let baselineWindowRatio;
  function initBrowserZoomDetection() {
    captureBaselinesIfNeeded();
  }
  function resetBrowserZoomStateForTests() {
    baselineDevicePixelRatio = undefined;
    baselineWindowRatio = undefined;
  }
  function setBrowserZoomBaselinesForTests(devicePixelRatio, windowRatio) {
    baselineDevicePixelRatio = devicePixelRatio;
    baselineWindowRatio = windowRatio;
  }
  function getBrowserZoomScale() {
    let visualViewport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getVisualViewport();
    captureBaselinesIfNeeded();
    const pinchScale = visualViewport?.scale ?? DEFAULT_ZOOM_SCALE;
    if (!isBrowserZoomAtDefault(pinchScale)) {
      return pinchScale;
    }
    const dprScale = getPageZoomScaleFromDevicePixelRatio();
    const windowScale = getPageZoomScaleFromWindowRatio();
    if (isBrowserZoomAtDefault(dprScale) && isBrowserZoomAtDefault(windowScale)) {
      recalibrateBaselinesToCurrent();
      return DEFAULT_ZOOM_SCALE;
    }
    if (isSafari()) {
      return windowScale;
    }

    // Chromium/Firefox reflect page zoom in both DPR and outer/inner width. When only one
    // signal reads zoomed, treat the page as 100% to avoid OS scaling false positives.
    if (isBrowserZoomAtDefault(dprScale) || isBrowserZoomAtDefault(windowScale)) {
      return DEFAULT_ZOOM_SCALE;
    }
    return dprScale;
  }
  function isBrowserZoomAtDefault() {
    let scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getBrowserZoomScale();
    let tolerance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ZOOM_TOLERANCE;
    return Math.abs(scale - DEFAULT_ZOOM_SCALE) <= tolerance;
  }
  function getBrowserZoomDirection() {
    let scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getBrowserZoomScale();
    if (isBrowserZoomAtDefault(scale)) {
      return null;
    }
    return scale > DEFAULT_ZOOM_SCALE ? 'zoomedIn' : 'zoomedOut';
  }
  function isMac() {
    let navigator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator;
    return /Mac|iPhone|iPod|iPad/i.test(navigator.platform || navigator.userAgent);
  }
  function isSafari() {
    let navigator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator;
    return /Safari/i.test(navigator.userAgent) && !/Chrome|Chromium|Edg|OPR|Firefox/i.test(navigator.userAgent);
  }
  function getBrowserZoomResetInstructionsKey() {
    let navigator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator;
    if (isSafari(navigator) && isMac(navigator)) {
      return 'errors.autoFix.previewZoomResetSafariMac';
    }
    if (isMac(navigator)) {
      return 'errors.autoFix.previewZoomResetMac';
    }
    return 'errors.autoFix.previewZoomResetWindows';
  }
  function captureBaselinesIfNeeded() {
    if (typeof window === 'undefined') {
      return;
    }
    if (baselineDevicePixelRatio === undefined) {
      baselineDevicePixelRatio = window.devicePixelRatio;
    }
    if (baselineWindowRatio === undefined && window.innerWidth > 0 && window.outerWidth > 0) {
      baselineWindowRatio = window.outerWidth / window.innerWidth;
    }
  }
  function recalibrateBaselinesToCurrent() {
    if (typeof window === 'undefined' || !window.innerWidth || !window.outerWidth) {
      return;
    }
    baselineDevicePixelRatio = window.devicePixelRatio;
    baselineWindowRatio = window.outerWidth / window.innerWidth;
  }
  function getPageZoomScaleFromDevicePixelRatio() {
    if (typeof window === 'undefined' || !baselineDevicePixelRatio) {
      return DEFAULT_ZOOM_SCALE;
    }
    return window.devicePixelRatio / baselineDevicePixelRatio;
  }
  function getPageZoomScaleFromWindowRatio() {
    if (typeof window === 'undefined' || !baselineWindowRatio || !window.innerWidth || window.innerWidth <= 0 || !window.outerWidth) {
      return DEFAULT_ZOOM_SCALE;
    }
    const currentRatio = window.outerWidth / window.innerWidth;
    return currentRatio / baselineWindowRatio;
  }
  function getVisualViewport() {
    if (typeof window === 'undefined') {
      return null;
    }
    return window.visualViewport;
  }
});